import { render, staticRenderFns } from "./PrivacyRequest.vue?vue&type=template&id=3f05fc6d&"
import script from "./PrivacyRequest.vue?vue&type=script&lang=js&"
export * from "./PrivacyRequest.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f05fc6d')) {
      api.createRecord('3f05fc6d', component.options)
    } else {
      api.reload('3f05fc6d', component.options)
    }
    module.hot.accept("./PrivacyRequest.vue?vue&type=template&id=3f05fc6d&", function () {
      api.rerender('3f05fc6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/legal_entities/tabs/PrivacyRequest.vue"
export default component.exports